<template>
  <div class="container">
    <div :class="{content: true, empty: list && list.length === 0}">
      <!-- 报道审核、我的报道样式 -->
      <div :class="['clueList', 'myClue', list && list.length === 0 ? 'empty' : '']">
        <div class="nav">
          <li>
            <label><img :src="allSelected ? icons.checkerOn : icons.checker" class="checker" alt="checker" @click="selectAll()"></label>
            <button class="batch" @click="handleAll(0)">批量通过</button>
            <button class="batchExit" @click="handleAll(1)">批量退回</button>
          </li>
        </div>
        <div class="list">
          <empty :mTop="30" v-if="list && list.length === 0" :msg="`暂无${$_syscfg.report}`" />
          <ul v-for="(item, index) in list" :key="index">
            <img v-if="item.has_warning" src="@assets/img/common/warnTag.svg" alt="warn" class="warning">
            <label><img :src="item.selected ? icons.checkerOn: icons.checker" class="checker" alt="checker" @click="selectOne(item)"></label>
            <div class="thumImg" @click="viewMedia(item)">
              <p class="tags" v-if="item.has_avid_icon || item.has_kankan_icon || item.has_iditor_icon">
                <img v-if="item.has_avid_icon" src="@assets/img/index/tv.svg" alt="tv">
                <img v-if="item.has_kankan_icon" src="@assets/img/index/kankan.svg" alt="kankan">
                <img v-if="item.has_iditor_icon" src="@assets/img/index/dxgg.svg" alt="dxgg">
              </p>
              <img @error="imgError(item)" class="cover" :src="item.img_url || defaultImg" alt="cover">
              <img v-if="item.play_icon - 0 === 1 && item.img_url" class="play" src="@assets/img/index/play.svg" alt="play">
            </div>
            <dl class="reportContent">
              <a href="#" @click.prevent="goDetail(item)">
                <h4 :class="{tips: item.has_change == 1, news: item.is_new == 1}">
                  <span :title="item.title">{{item.title}}</span>
                  <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="item.has_img - 0 === 1">
                  <img src="@assets/img/common/videoIcon.svg" alt="video" v-if="item.has_video - 0 === 1">
                  <img src="@assets/img/common/audioIcon.svg" alt="audio" v-if="item.has_sound - 0 === 1">
                  <!-- todo 22 -->
                  <img alt="技审未通过" title="技审未通过" class="verify-logo" v-if="item.has_audit&&item.has_audit==2" src="@assets/img/common/verify-fail.svg">
                </h4>
              </a>
              <li>{{item.content}}</li>
              <li class="smal">
                <span :class="{card: item.uid != 0}" @click="showCard(item.uid, $event)">
                  {{item.user_name}}
                </span>
                <span>{{item.add_time}}</span>
              </li>
            </dl>
            <!-- 报道审核 -->
            <div class="creat">
              <button class="success" v-if="item.has_publish" @click="pushPublish(item.report_id, 'report')">{{`推送${$_syscfg.publish}`}}</button>
              <button @click="goEdit(item.report_id)">编辑</button>
              <button class="success" @click="handleReport(item.report_id, 0)">通过</button>
              <button @click="handleReport(item.report_id, 1)">退回</button>
            </div>
          </ul>
        </div>
        <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
  </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import pages from "@components/pages";
import empty from "@components/empty";

export default {
  components: { pages, empty },
  data() {
    return {
      isXnew: this.$store.state.isXnew,
      defaultImg: require("@assets/img/common/default.png"),
      list: null,
      page: {
        pageSize: 10,
        pageIndex: 1,
        pageCount: 0,
        total: 0
      },
      backShow: false,
      icons: {
        checker: require("@assets/img/interview/checker.svg"),
        checkerOn: require("@assets/img/interview/checkerOn.svg")
      },
      allSelected: false,
      searchOptions: {}
    };
  },
  methods: {
    showCard(id, e) {
      if (id == 0) return;

      const el = e.target;

      this.$card(id, el);
    },
    imgError(i) {
      // 图片加载状态
      this.$set(i, "img_url", this.defaultImg);
    },
    goDetail(i) {
      // 去详情页
      this.$set(i, "has_change", 0);
      this.$set(i, "is_new", 0);
      common.jump(`/reportCheck?d=${i.report_id}&c=t`, true);
    },
    viewMedia(item) {
      // 浏览稿件媒体
      common.openMaterialBox(null, null, false, item.report_id, 1);
      // common.viewMedia(null, null, false, item.report_id, 1)
    },
    async goEdit(id) {
      // 跳转编辑
      // const checked = await common.checkPageStatus(id, 1)
      // if (!checked) return

      // common.jump(`/editReport?d=${id}`, true)

      const newWindow = window.open();
      common.checkPageStatus(id, 1).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin
            }/editReport?d=${id}`;
        } else {
          newWindow.close();
        }
      });
    },
    async handleReport(id, status) {
      // 审核／退回报道
      let msg = `确定通过${this.$_syscfg.report}吗？`;
      if (status === 1) {
        msg = `确定退回${this.$_syscfg.report}吗? `;
      }
      const confirm = await this.$confirm(msg);
      if (!confirm) return;

      let info = {
        report_id: id,
        status: status
      };

      common.myFetch(apis.Rpt_handle_report, info).then(res => {
        if (res) {
          this.$toast(res);
          this.getList();
        }
      });
    },
    handleAll(status) {
      // 批量通过／退回
      const ids = [];
      this.list.forEach(i => {
        if (i.selected) {
          ids.push(i.report_id);
        }
      });
      if (ids.length === 0) {
        this.$toast("请至少选择一项");
        return;
      }

      this.handleReport(ids.join(","), status);
    },
    getList() {
      // 获取列表
      const id = this.$route.params.id;
      let data = {
        idstring: id,
        search_option: "",
        key_words: "",
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      };
      Object.assign(data, this.searchOptions);

      common.myFetch(apis.checkReport, data, "post").then(res => {
        if (res) {
          this.allSelected = false;
          this.list = res.list;
          this.generateSearchs(res.params.top_search.option.list);
          this.$set(
            this.page,
            "pageCount",
            common.calculatePage(res.page.row_count - 0, this.page.pageSize)
          );
          this.$set(this.page, "total", res.page.row_count - 0);
        }
      });
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.postSearch(filterData);
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit("filterData", data);
    },
    selectAll() {
      // 全选／反选
      this.allSelected = !this.allSelected;

      this.list.forEach(i => {
        this.$set(i, "selected", this.allSelected);
      });
    },
    selectOne(i) {
      // 选择 ／ 反选
      this.$set(i, "selected", !i.selected);

      this.$nextTick(() => {
        if (!i.selected) {
          this.allSelected = false;
        }
      });
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.getList();
  }
};
</script>

<style src="@assets/css/reportEditor/reportEditor.less" lang="less" scoped>
</style>
